// Hand-built editor DOM class names, centralized so createDOM/.vue render and exportDOM never drift (Lexical node-type classes live in EditorTheme.js).

export const blockRhythm = 'gfu-editor__block';
export const blockFlush = 'gfu-editor__block--flush';
export const blockFrame = 'gfu-editor-block';            // also the drag target selector
export const blockImage = 'gfu-editor-block--image';
export const blockVideo = 'gfu-editor-block--video';
export const blockEmbed = 'gfu-editor-block--embed';
export const blockCarousel = 'gfu-editor-block--carousel';
export const blockSeparator = 'gfu-editor-block--separator';
export const blockCaption = 'gfu-editor-block__caption';
export const embedIframe = 'gfu-editor-block__embed-iframe';

// Legacy responsive embed wrapper (shared with the public richtext embed styles)
export const embed = 'gfu-embed';
export const embed16x9 = 'gfu-embed--16x9';
export const embedItem = 'gfu-embed__item';

export const attachment = 'gfu-editor-attachment';
export const sectionHeader = 'gfu-editor-section-header';
export const separator = 'gfu-editor-separator';

export const celebration = 'gfu-editor-celebration';

export const targetLine = 'gfu-editor-target-line';
